export default __webpack_public_path__ + "static/media/og-logo.791bce49.png";